"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
/**
 * @component ProgressBar
 * @example
 * return (
 *  <ProgressBar
 *    completeness={3.57}
 *    headerText="header text"
 *  />
 * )
 *
 * @param {string} headerText a string for the text to show above the loading bar
 * @param {number} completeness how complete the bar is; max value is 10.
 * @returns
 */
var ProgressBar = function (props) {
    var headerText = props.headerText, completeness = props.completeness;
    return (react_1.default.createElement("main", { className: "px-2 py-2", style: { borderRadius: '5px' } },
        react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "space-between", spacing: 2 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 9, style: { marginTop: -5 } },
                react_1.default.createElement(material_1.Typography, { variant: "body2" }, headerText)),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 3 },
                react_1.default.createElement(material_1.Typography, { variant: "body2" }, "".concat(completeness, "/10"))),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.LinearProgress, { variant: "determinate", value: completeness * 10 })))));
};
exports.default = ProgressBar;
